<template>
  <div class="k-empty">
    <div class="k-empty__media">
      <slot name="media">
        <v-icon v-if="icon" :icon="icon" size="56" color="primary" class="k-empty__breathe" />
        <svg v-else class="k-empty__illustration k-empty__breathe" width="96" height="88" viewBox="0 0 96 88" aria-hidden="true">
          <rect x="8" y="16" width="68" height="60" rx="16" class="k-empty__card" />
          <rect x="20" y="34" width="26" height="6" rx="3" class="k-empty__line" />
          <rect x="20" y="48" width="44" height="5" rx="2.5" class="k-empty__line k-empty__line--soft" />
          <rect x="20" y="60" width="34" height="5" rx="2.5" class="k-empty__line k-empty__line--soft" />
          <circle cx="68" cy="22" r="14" class="k-empty__badge" />
          <path d="M61 22.5l5 5 9-10" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </slot>
    </div>
    <div class="k-empty__title">{{ title }}</div>
    <div v-if="description" class="k-empty__description">{{ description }}</div>
    <div v-if="actionLabel || $slots.actions" class="k-empty__actions">
      <slot name="actions">
        <v-btn color="primary" @click="$emit('action')">{{ actionLabel }}</v-btn>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "KEmptyState",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    actionLabel: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
  },
  emits: ["action"],
};
</script>

<style scoped>
.k-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px;
  text-align: center;
}

.k-empty__media {
  margin-bottom: 4px;
}

.k-empty__breathe {
  animation: k-empty-breathe 4.2s ease-in-out infinite;
  will-change: transform;
}

.k-empty__card {
  fill: color-mix(in srgb, rgb(var(--v-theme-on-surface)) 12%, transparent);
  stroke: var(--k-glass-border);
  stroke-width: 1.5;
}

.k-empty__line {
  fill: rgb(var(--v-theme-primary));
}

.k-empty__line--soft {
  fill: color-mix(in srgb, rgb(var(--v-theme-on-surface)) 30%, transparent);
}

.k-empty__badge {
  fill: rgb(var(--v-theme-primary));
}

.k-empty__title {
  font-size: 14px;
  font-weight: 600;
}

.k-empty__description {
  font-size: 12px;
  opacity: 0.7;
}

.k-empty__actions {
  margin-top: 8px;
}

@keyframes k-empty-breathe {
  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1);
  }

  50% {
    transform: translate3d(0, -6px, 0) scale(1.03);
  }
}

@media (prefers-reduced-motion: reduce) {
  .k-empty__breathe {
    animation: none;
  }
}
</style>
